module.exports = __webpack_public_path__ + "static/media/image2vector.6f3eb087.svg";